
/**
 * @export
 * @enum {string}
 */
export enum UserStatus {
    EMPTY = 'EMPTY',
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    SUSPENDED = 'SUSPENDED'
}